import { Button } from "@chakra-ui/react";

/**
 *
 * @param {import("@chakra-ui/react").ButtonProps} props
 */
export const WorkflowButton = ({ children, ...rest }) => {
  return (
    <Button
      w="full"
      size="lg"
      borderRadius="5px"
      py={3}
      px={6}
      bgGradient="linear(to-t, blue.900, blue.700)"
      color="white"
      fontWeight="600"
      boxShadow="0 2px 4px rgba(0, 0, 0, 0.2)"
      border="1px solid transparent"
      transition="all 0.3s ease"
      _hover={{
        bgGradient: "linear(to-t, blue.800, blue.600)",
        transform: "translateY(-2px)",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
      }}
      _active={{
        bgGradient: "linear(to-t, blue.900, blue.800)",
        transform: "translateY(1px)",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.3)",
      }}
      _focus={{
        boxShadow: "0 0 0 3px rgba(30, 58, 108, 0.4)",
        outline: "none",
      }}
      {...rest}>
      {children}
    </Button>
  );
};
